"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _icons = require("../../assets/icons");
var _ToolTip = _interopRequireDefault(require("../ToolTip"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
(function _() {
  var styles = ".Label {\n  display: flex;\n  justify-content: space-between;\n}\n.Label__text_wrapper {\n  margin-left: 0.25rem;\n  line-height: 1.5rem;\n  display: inline-flex;\n  align-items: center;\n  flex-direction: row;\n  outline: none;\n}\n.Label__text {\n  align-items: center;\n  color: #262626;\n  font-size: 0.875rem;\n  line-height: 1.5rem;\n  font-weight: normal;\n  display: flex;\n}\n.Label__text__error {\n  color: #c60f13;\n}\n.Label__text__helper_text {\n  display: flex;\n  align-items: center;\n  font-size: 0.75rem;\n  line-height: 1rem;\n  color: #424242;\n  margin-left: 0.5rem;\n  margin-right: 0.25rem;\n}\n.Label__text__required {\n  line-height: 1rem;\n  color: #c60f13;\n  margin: -0.25rem 0.25rem 0 0.25rem;\n}\n.Label__tooltip {\n  line-height: 1rem;\n  margin-left: 0.23rem;\n}\n.Label__tooltip.addMoreMargin {\n  margin-left: 0.48rem;\n}\n.Label__show_hide {\n  background: none;\n  border: 0;\n  cursor: pointer;\n  color: #767676;\n  display: inline-flex;\n  align-items: center;\n  line-height: 1rem;\n}\n.Label__show_hide__text {\n  padding-right: 0.25rem;\n  font-size: 0.75rem;\n  color: #0a5ec0;\n}";
  var fileName = "Label_Label";
  var element = document.querySelector("style[data-sass-component='Label_Label']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
/**
 * A segment of text that is meant to be displayed above an input component. It helps describe what data the input is requesting.
 */
var Label = function Label(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    children = _ref.children,
    helperText = _ref.helperText,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$showHide = _ref.showHide,
    showHide = _ref$showHide === void 0 ? false : _ref$showHide,
    tooltip = _ref.tooltip,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    _ref$tooltipAlign = _ref.tooltipAlign,
    tooltipAlign = _ref$tooltipAlign === void 0 ? 'bottom-left' : _ref$tooltipAlign,
    _ref$mobileTooltipAli = _ref.mobileTooltipAlign,
    mobileTooltipAlign = _ref$mobileTooltipAli === void 0 ? 'bottom-right' : _ref$mobileTooltipAli;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showValue = _useState2[0],
    setShowValue = _useState2[1];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "Label ".concat(className),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "Label__text_wrapper",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "Label__text ".concat(error ? 'Label__text__error' : '', " "),
        children: children
      }), helperText && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: "Label__text__helper_text",
        children: ["(", helperText, ")"]
      }), required && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "Label__text__required",
        children: "*"
      }), tooltip && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ToolTip["default"], {
        className: "Label__tooltip ".concat(!required ? 'addMoreMargin' : ''),
        notchPosition: tooltipAlign,
        mobileNotchPosition: mobileTooltipAlign || tooltipAlign,
        children: tooltip
      })]
    }), showHide && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      className: "Label__show_hide",
      onClick: function onClick() {
        setShowValue(!showValue);
        if (showHide.callback) {
          showHide.callback(!showValue);
        }
      },
      type: "button",
      children: showValue ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "Label__show_hide__text",
          children: showHide.hideText || 'Hide'
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.IconHide, {
          "aria-label": "Hide field value",
          role: "button"
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "Label__show_hide__text",
          children: showHide.showText || 'Show'
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.IconShow, {
          "aria-label": "Show field value",
          role: "button"
        })]
      })
    })]
  });
};
var _default = Label;
exports["default"] = _default;